var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.layoutType === 'vertical')?_c('Vertical',{attrs:{"layout":_vm.layoutType}},[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }